var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 55,
    viewBox: "0 0 63 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0095 54.5H6.99075C6.9905 54.5 6.99024 54.5 6.98999 54.5C2.54554 54.4994 -0.232503 49.6878 1.99005 45.8391L1.99007 45.839L26.5002 3.3868L26.5002 3.38678C28.7222 -0.462206 34.278 -0.462331 36.5008 3.38684L61.0101 45.839C63.2322 49.6881 60.4542 54.5 56.0095 54.5Z",
    stroke: "#D91734"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61748 47.9392L30.1268 5.48697C30.5242 4.79864 31.1563 4.69531 31.4974 4.69531C31.8385 4.69531 32.4706 4.79788 32.8687 5.48697L57.3781 47.9392C57.7754 48.6283 57.549 49.227 57.3781 49.5225C57.2071 49.818 56.8022 50.3141 56.0075 50.3141H6.98805C6.1926 50.3141 5.78766 49.818 5.61748 49.5225C5.44653 49.227 5.22013 48.6283 5.61748 47.9392Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4958 46.0503C33.1868 46.0503 34.5576 44.6097 34.5576 42.8328C34.5576 41.0558 33.1868 39.6152 31.4958 39.6152C29.8049 39.6152 28.4341 41.0558 28.4341 42.8328C28.4341 44.6097 29.8049 46.0503 31.4958 46.0503Z",
    fill: "#2C2C2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6156 18.9726L32.9685 37.1168H30.0442L28.3834 18.9748C28.2155 17.1416 29.659 15.5605 31.4999 15.5605C33.3392 15.5605 34.7812 17.1408 34.6148 18.9726H34.6156Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b13c185b232b54e58fd53e088a47356f.svg";
export { ForwardRef as ReactComponent };